import React, { useRef, useState, useEffect } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserTie } from "@fortawesome/free-solid-svg-icons";
import thankyouimg from "../assets/payment/thankyou.png";
import { useNavigate, useLocation } from 'react-router-dom';

const CouponThankyou = () => {
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    setTimeout(() => {
        navigate('/');
    }, 10000);
  }, []);

  return (
    <div className="cartheader">
      <Header />
      <div className="course-details-topborder"></div>
      <div className="pagewidth">
        <div className="thankyousection">
          <div className="row">
            <div className="col-12 col-md-6">
              <p className="thankyouhead">Thank You!</p>
              <p className="thankyoudesc">Your form has been successfully submitted.
                We appreciate your interest in UpskillsCert.</p>
              <p className="thankyoudesc thankyoudesc-needhelp"><b>"YED10"</b> Use this coupon code during checkout</p>
              <p className="thankyoudesc">In the meantime, feel free to explore more about our courses and certifications.</p>
              <p className="thankyoudesc">You will be redirected to homepage shortly.</p>
            </div>
            <div className="col-12 col-md-6">
                <img src={thankyouimg} className="thankyouimg" />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CouponThankyou;
